import ActionTypes from "../../../constants";
import { BusinessPartnerType } from "../../BusinessPartnerDetails/types";
import { PaginationInfoType } from "../../BusinessPartnerLists/types";
import { UpdateNotificationPayloadType, NotificationType, NotificationUpdatedPayload } from '../types'
export interface fetchNotificatonActionType {
  type: typeof ActionTypes.FETCH_NOTIFICATION;
}
export interface fetchNotificatonSucceededActionType {
  type: typeof ActionTypes.FETCH_NOTIFICATION_SUCCEEDED;
  notifications: NotificationType[];
  pageInfo: PaginationInfoType;
}

export const fetchNotificaton = (): fetchNotificatonActionType => ({
  type: ActionTypes.FETCH_NOTIFICATION
});
export const fetchNotificatonSucceeded = (
  notifications: NotificationType[],
  pageInfo: PaginationInfoType
) => ({
  type: ActionTypes.FETCH_NOTIFICATION_SUCCEEDED,
  notifications,
  pageInfo
});

export interface UpdateNotificationActionType {
  type: typeof ActionTypes.UPDATE_NOTIFICATION,
  payload: UpdateNotificationPayloadType;
}

export const updateNotification = (payload: UpdateNotificationPayloadType): UpdateNotificationActionType => ({
  type: ActionTypes.UPDATE_NOTIFICATION,
  payload
});

export interface UpdateNotificationSucceededActionType {
  type: typeof ActionTypes.UPDATE_BUSINESS_PARTNER_SUCCEEDED,
  payload: NotificationUpdatedPayload;
}

export const updateNotificationSucceeded = (payload: NotificationUpdatedPayload): UpdateNotificationSucceededActionType => ({
  type: ActionTypes.UPDATE_NOTIFICATION_SUCCEEDED,
  payload
});
export const resetNotificationUpdatedFlag = () => ({
  type: ActionTypes.RESET_NOTIFICATION_UPDATED_FLAG
});
